import { ReactNode } from 'react';
import { isFirstDayOfBusinessWeek, isLastVisible } from '../helpers';
import { WorkloadWeek } from './week';
import { getFirstDayOfBusinessWeek } from '@contexts/workload/constants';
import { WorkloadDraftsDetailsItem } from '@services/workload/calendar/types';

export const isFirstVisible = (index: number): boolean => index === 0;

export const renderWeek = (dates: Date[], item: Date, index: number): ReactNode => {
  const firstDisplayedDate = dates[0].getTime();
  const firstDayOfBusinessWeekOfItem = getFirstDayOfBusinessWeek(item).getTime();

  const isFirstDayOfBusinessWeekVisible: boolean = dates
    .map((el) => el.getTime())
    .includes(firstDayOfBusinessWeekOfItem);

  const isWeekVisible: boolean =
    isFirstDayOfBusinessWeek(item) ||
    isFirstVisible(index) ||
    (!isFirstDayOfBusinessWeekVisible &&
      firstDisplayedDate === firstDayOfBusinessWeekOfItem &&
      isLastVisible(dates, index));

  if (isWeekVisible) return <WorkloadWeek date={item} first={!index} />;
  return null;
};

export const isSendDisabled = ({
  total,
  totalSchedules,
  uniqueForemenIds,
  schedulesIds,
}: WorkloadDraftsDetailsItem) => {
  if ((uniqueForemenIds?.length || 0) === 0) return true;
  if (!schedulesIds.length) return true;
  return !total && !totalSchedules && total === totalSchedules;
};

export const getDraftsColor = (data: WorkloadDraftsDetailsItem) => {
  const { total, totalSchedules } = data;
  if (total && totalSchedules && total !== totalSchedules)
    return 'text-warning-300 hover:text-warning-500';
  if (!total && !totalSchedules) return 'text-primary-300 hover:text-primary-500';
  if (total !== 0 && totalSchedules && total === totalSchedules)
    return 'text-neutral-500 hover:text-neutral-700';
};
